module.exports = {
      id: "slider-next-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#slider-next",
      toString: function () {
        return this.url;
      }
    }